export default __webpack_public_path__ + "static/media/btn-color-uk_en@3x.644a71b8.png";